import { strings, type Lang } from "./strings";

const STORAGE_KEY = "gb_lang";
const subs = new Set<(l: Lang) => void>();

let current: Lang = detectInitial();

function detectInitial(): Lang {
  const saved = (typeof localStorage !== "undefined" && localStorage.getItem(STORAGE_KEY)) as Lang | null;
  if (saved === "en" || saved === "zh") return saved;
  if (typeof navigator !== "undefined" && navigator.language?.toLowerCase().startsWith("zh")) return "zh";
  return "en";
}

export function getLang(): Lang {
  return current;
}

export function setLang(l: Lang) {
  if (l === current) return;
  current = l;
  if (typeof localStorage !== "undefined") localStorage.setItem(STORAGE_KEY, l);
  for (const fn of subs) fn(l);
}

export function t(key: string): string {
  return strings[current][key] ?? key;
}

export function onLangChange(fn: (l: Lang) => void): () => void {
  subs.add(fn);
  return () => subs.delete(fn);
}
